@if (title || subtitle || onlyRadio) {
  <div class="d-flex gap-m justify-content-space-between align-items-center">
    <div>
      @if (title) {
        <p class="fs-24 fw-600 man">{{ title }}</p>
      }
      @if (subtitle) {
        <span class="fs-16 text-secondary">{{ subtitle }}</span>
      }
    </div>
    <ng-content select="[choices]"></ng-content>
  </div>
}
@if (title) {
  <pr-separator></pr-separator>
}
@if (search) {
  <pr-search-input
    [(searchValue)]="searchValue"
    [searchProperty]="searchProperty"
    [(dataListSearched)]="dataSearched"
    [list]="data"
    [placeholder]="placeholder"
    class="mbm"
  >
  </pr-search-input>
}
<ng-content select="[custom]"></ng-content>
<mat-accordion hideToggle displayMode="flat">
  @for (
    entity of pagination ? dataPaginated : search ? dataSearched : data;
    track entity
  ) {
    <pr-list-item
      [entity]="entity"
      [columns]="columns"
      [iconTemplate]="iconTemplate"
      [bodyTemplate]="bodyTemplate"
      [expandable]="expandable"
      [expanded]="expanded"
      [redirect]="redirect"
      [maxHeaderElems]="maxHeaderElems"
      (click)="onItemClicked.emit({ $event, entity })"
    >
    </pr-list-item>
  }
</mat-accordion>
@if (pagination) {
  <pr-pagination-v2
    [(dataListPaginated)]="dataPaginated"
    [dataList]="search ? dataSearched : data"
    [itemsPerPage]="itemsPerPage"
  >
  </pr-pagination-v2>
}

@if (
  (pagination ? dataPaginated : search ? dataSearched : data)?.length == 0 &&
  !loading
) {
  <div class="empty-container">
    <div>
      <ng-content select="[emptyTemplate]"></ng-content>
    </div>
  </div>
}

@if (loading) {
  <div class="loader">
    <pr-loader type="lists"></pr-loader>
  </div>
}
